import axios, { AxiosRequestConfig } from 'axios';
import { stringify } from 'qs';
import config from '@config';

import { FilterState } from '@config/DisturbanceFilter';

export const API_CONF: AxiosRequestConfig = {
  baseURL: config.apiUrl || '/disturbance-frontend-api',
  timeout: 50000,
  withCredentials: config.credentialsAllowed,
  paramsSerializer: {
    serialize: (params) =>
      stringify(params, {
        arrayFormat: 'comma',
        allowDots: true
      })
  }
};

export const DISTURBANCE_BASE_URL = '/disturbance';

const API = axios.create(API_CONF);

export default API;

export function getAuthType(isLoggedIn: boolean, isDealer: boolean) {
  if (isDealer) {
    return 'internal';
  } else if (isLoggedIn) {
    return 'external';
  }
  return 'public';
}

export function removeNullFilterValues(filter: FilterState): any {
  Object.keys(filter).forEach((key) => {
    const filterKey = key as keyof FilterState;
    if (filter[filterKey] === null || filter[filterKey].length < 1) {
      delete filter[filterKey];
    }
  });
}

export function removeEmptyKeys(filter: FilterState) {
  return Object.entries(filter)
    .filter(([{}, v]) => (typeof v === 'string' && v !== '') || (typeof v === 'object' && Object.keys(v).length))
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
}
